export default "__VITE_ASSET__DP231$p0__"